import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PrimaryNavRail } from '../components/map/PrimaryNavRail';
import { api } from '../lib/api';
import type { Me } from '../lib/types';

function initialsOf(me: Me | null): string {
  if (!me) return '…';
  const a = me.first_name?.[0] ?? '';
  const b = me.last_name?.[0] ?? '';
  return (a + b).toUpperCase() || '??';
}

export function EmptyWorkspacePage() {
  const [me, setMe] = useState<Me | null>(null);

  useEffect(() => {
    api.getMe().then(setMe).catch(() => {});
  }, []);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-bg-canvas">
      <PrimaryNavRail userInitials={initialsOf(me)} userAvatarUrl={me?.avatar_url} />

      <div className="flex flex-1 items-center justify-center">
        <div className="flex w-[440px] flex-col items-center rounded-2xl border border-border-default bg-bg-surface p-10 text-center">
          <span className="flex size-16 items-center justify-center rounded-2xl bg-action-primary text-3xl text-text-inverse">
            ⌂
          </span>
          <h1 className="mt-6 text-xl font-semibold text-text-primary">В этом пространстве пока нет карты</h1>
          <p className="mt-2 text-sm text-text-secondary">
            Любое хранилище данных начинается с карты — создайте первую карту, чтобы затем добавить в неё слои
            и подложки.
          </p>
          <Link
            to="/app/map-settings"
            className="mt-6 flex h-11 items-center justify-center rounded-[10px] bg-action-primary px-6 text-sm font-medium text-text-inverse hover:bg-action-primary-hover"
          >
            + Создать карту
          </Link>
        </div>
      </div>
    </div>
  );
}
